import { css } from 'styled-components'

const TripMapCSS = css`
  .trip-map-route-container {
    pointer-events: none;
  }
`

export default TripMapCSS
